import './Footer.css';
import { IconShield, IconClock, IconMap, IconTracking } from './Icons';

const PILLARS = [
  { icon: IconShield, label: 'Segurança' },
  { icon: IconClock, label: 'Pontualidade' },
  { icon: IconMap, label: 'Cobertura Nacional' },
  { icon: IconTracking, label: 'Rastreamento' },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" aria-label="Rodapé">
      <div className="container">
        <div className="footer-pillars row g-4 justify-content-center mb-4">
          {PILLARS.map(({ icon: Icon, label }) => (
            <div key={label} className="col-6 col-md-3 text-center">
              <div className="footer-pillar">
                <div className="icon-circle mx-auto">
                  <Icon />
                </div>
                <span>{label}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="row align-items-center gy-4">
          <div className="col-lg-4 text-center text-lg-start">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/logo_white.png`}
              alt="Tr Silva Bueno Transportes e Logística"
              className="footer-logo footer-logo-dark"
              loading="lazy"
              width="180"
              height="50"
            />
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
              alt="Tr Silva Bueno Transportes e Logística"
              className="footer-logo footer-logo-light"
              loading="lazy"
              width="180"
              height="50"
            />
          </div>
          <div className="col-lg-4 text-center">
            <p className="footer-tagline">
              Agilidade, <strong>Excelência</strong> e Compromisso
            </p>
            <p className="footer-text mb-0">
              CNPJ 22.430.496/0001-76
            </p>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <nav aria-label="Links do rodapé">
              <a href="#inicio" className="footer-link">Início</a>
              <a href="#sobre" className="footer-link">Quem Somos</a>
              <a href="#servicos" className="footer-link">Serviços</a>
              <a href="#contato" className="footer-link">Contato</a>
            </nav>
          </div>
        </div>
        <hr className="footer-divider" />
        <p className="footer-copy text-center mb-0">
          &copy; {currentYear} Tr Silva Bueno Transportes Ltda. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
